import { FormCondition, SpecialConditionData } from '@urbanx/agx.campaigns.client';
import { AgxSettlementDate } from '@urbanx/agx.ui-components2';
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps';
import { useEffect } from 'react';
import { SETTLEMENT_DATE_STEP_NAME, isSettlementDateComplete } from './ContractComplianceHelper';

interface ContractComplianceSettlementDateProps extends TaskModalPageProps {
  settlementInfo?: FormCondition;
  specialConditions?: SpecialConditionData[];
  onSettlementDateValidationErrorChange?: (hasValidationError: boolean) => void;
  onSettlementInfoUpdated?: (settlementInfo: FormCondition | undefined) => void;
}

const ContractComplianceSettlementDate = ({
  campaign,
  onSettlementDateValidationErrorChange,
  onSettlementInfoUpdated,
  settlementInfo,
  specialConditions = [],
  task,
  toggleTaskStep,
}: ContractComplianceSettlementDateProps) => {
  const SETTLEMENT_DATE_LABEL = 'Settlement Date';
  const step = task.taskSteps?.find((taskStep) => taskStep.name === SETTLEMENT_DATE_STEP_NAME);

  const isValid = isSettlementDateComplete(settlementInfo);

  useEffect(() => {
    if (!step?.order) return;

    if ((step.isCompleted ?? false) !== isValid) {
      toggleTaskStep(step.order, isValid);
    }
  }, [isValid, step?.isCompleted, step?.order, toggleTaskStep]);

  return (
    <AgxSettlementDate
      id="contract-compliance-settlement-date"
      label={SETTLEMENT_DATE_LABEL}
      defaultValue={settlementInfo}
      validate
      required
      showSpecialConditionOption
      showPayableOptions
      specialConditions={specialConditions}
      campaignId={campaign.campaignId ?? ''}
      onIsValidChange={(isValid) => {
        onSettlementDateValidationErrorChange?.(Boolean(settlementInfo?.condition) && !isValid);
      }}
      onValueChanged={({ value }) => {
        onSettlementInfoUpdated?.(value);
      }}
    />
  );
};

export default ContractComplianceSettlementDate;
